"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Query_1 = require("../query/Query");
var object_1 = require("../utils/object");
var QueryStore = /** @class */ (function () {
    function QueryStore() {
    }
    QueryStore.prototype.mergeQueriesAndProps = function (componentOrchestration) {
        if (componentOrchestration) {
            var props = componentOrchestration.props, queries = componentOrchestration.queries;
            var queryResults = queries ? Query_1.Query.convertQueryMime(queries, this.executionOptions) : {};
            var response = object_1.deepMergeObjects(props || {}, queryResults);
            return response;
        }
    };
    return QueryStore;
}());
exports.QueryStore = QueryStore;
//# sourceMappingURL=QueryStore.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/stores/QueryStore.js
// module id = 827
// module chunks = 1